import { useContext } from "react";

import { CreateFileRecordStateContext, ICreateFileRecordStateContext } from "./CreateFileRecordStateContext";

export const useCreateFileRecordState = (): ICreateFileRecordStateContext => {
    return useContext(CreateFileRecordStateContext);
};
